import { questionConstants } from "../constants/questionConstants";

const initialState = {
  sendingQustion: false,
  sendedQuestion: false,
  error: "",
  updatedQuestion: {},
  deleting: false,
  deleted: false,
  deletedQuestion: {},
  sendingAnswer: false,
  sendedAnswer: false,
  addedAnswerResponse: {},
  receivingQuestion: false,
  receivedQuestion: false,
  questionList: {},
  receivingDetails: false,
  receivedDetails: false,
  questionDetails: {}
};

export default function questionReducer(state = initialState, action) {
  switch (action.type) {
    case questionConstants.ADD_QUESTION_REQUEST:
      return {
        ...state,
        sendingQustion: true,
        sendedQuestion: false
      };
    case questionConstants.ADD_QUESTION_SUCCESS:
      return {
        ...state,
        sendingQustion: false,
        sendedQuestion: true,
        addedQuestionResponse: action.data,
        error: ""
      };
    case questionConstants.ADD_QUESTION_FAILURE:
      return {
        ...state,
        sendedQuestion: false,
        sendingQustion: false,
        error: action.error
      };
    case questionConstants.ADD_ANSWER_REQUEST:
      return {
        ...state,
        sendingAnswer: true,
        sendedAnswer: false
      };
    case questionConstants.ADD_ANSWER_SUCCESS:
      return {
        ...state,
        sendingAnswer: false,
        sendedAnswer: true,
        addedAnswerResponse: action.data,
        error: ""
      };
    case questionConstants.ADD_ANSWER_FAILURE:
      return {
        ...state,
        sendedAnswer: false,
        sendingAnswer: false,
        error: action.error
      };
    case questionConstants.GET_QUESTION_REQUEST:
      return {
        ...state,
        receivingQuestion: true,
        receivedQuestion: false
      };
    case questionConstants.GET_QUESTION_SUCCESS:
      return {
        ...state,
        receivingQuestion: false,
        receivedQuestion: true,
        questionList: action.data.data,
        error: ""
      };
    case questionConstants.GET_QUESTION_FAILURE:
      return {
        ...state,
        receivingQuestion: false,
        receivedQuestion: false,
        error: action.error
      };
    case questionConstants.DELETE_QUESTION_REQUEST:
      return {
        ...state,
        deleting: true,
        deleted: false
      };
    case questionConstants.DELETE_QUESTION_SUCCESS:
      return {
        ...state,
        deleting: false,
        deleted: true,
        deletedQuestion: action.data,
        error: ""
      };
    case questionConstants.DELETE_QUESTION_FAILURE:
      return {
        ...state,
        deleted: false,
        deleting: false,
        error: action.error
      };
    case questionConstants.GET_QUESTION_DETAILS_REQUEST:
      return {
        ...state,
        receivedDetails: false,
        receivingDetails: true
      };
    case questionConstants.GET_QUESTION_DETAILS_SUCCESS:
      return {
        ...state,
        receivingDetails: false,
        receivedDetails: true,
        questionDetails: action.data.data,
        error: ""
      };
    case questionConstants.GET_QUESTION_DETAILS_FAILURE:
      return {
        ...state,
        receivingDetails: false,
        receivedDetails: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/questionReducer.js